import DetailsModelTableRow from '../details-model-table-row';

const DetailsModalTableDirectCost = ({ tableData, hideDetails }) => {
  const { labor_cost, material_cost, equipment_cost, subcontractor_cost, other_cost } = tableData;

  const direct_cost = labor_cost + material_cost + equipment_cost + subcontractor_cost + other_cost;

  return (
    <DetailsModelTableRow
      title="Direct Cost"
      values={[
        labor_cost,
        material_cost,
        equipment_cost,
        subcontractor_cost,
        other_cost,
        direct_cost,
      ].map((item) => `$${item.toFixed(2)}`)}
      hideDetails={hideDetails}
    />
  );
};

export default DetailsModalTableDirectCost;
